import _ from "lodash";
import React, { useEffect, useState } from "react";
import { mutate } from "swr";
import DeletePlaylistModal from "./DeletePlaylistModal";
import CardSwitcher from "../cards/CardSwitcher";
import { makeRequest } from "../../utils/request";

const PlaylistView = ({ playlist, playlists, deletePlaylist, selectedContentKeys }) => {
  const [showModal, setShowModal] = useState(false);
  const [itemType, setItemType] = useState(null);
  const [setToDelete, setSetToDelete] = useState(null);
  const [posts, setPosts] = useState();
  const [loading, setLoading] = useState(false);
  const deleteContentFromPlaylist = async (keysToDelete, items) => {
    if (items !== "allItems") {
      const contentKeys = playlist.contentKeys.filter(
        x => !keysToDelete[0].contentKey.includes(x)
      );
      let newPlaylist = {
        ...playlist,
        contentKeys
      };
      const updateDeletedPosts = _.filter(posts, function (post) {
        return post.contentKey !== keysToDelete[0].contentKey;
      });;
      setPosts(updateDeletedPosts);
      const resPlaylist = await makeRequest("post", "/api/playlist", newPlaylist);
      const newPlaylists = JSON.parse(JSON.stringify(playlists));
      const currentPlaylist = newPlaylists.findIndex(
        x => x.id === resPlaylist.id
      );
      newPlaylists[currentPlaylist] = resPlaylist;
      await mutate("/api/playlist/getallplaylists", newPlaylists);
    } else {
      setPosts([]);
      const contentKeys = [];
      let newPlaylist = {
        ...playlist,
        contentKeys
      };
      const resPlaylist = await makeRequest("post", "/api/playlist", newPlaylist);
      const newPlaylists = JSON.parse(JSON.stringify(playlists));
      const currentPlaylist = newPlaylists.findIndex(
        x => x.id === resPlaylist.id
      );
      newPlaylists[currentPlaylist] = resPlaylist;
      await mutate("/api/playlist/getallplaylists", newPlaylists);
    }
  };

  const deleteItem = () => {
    if (itemType === "playlist") {
      deletePlaylist(playlist);
    } else if (itemType === "allItems") {
      deleteContentFromPlaylist(playlist.contentKeys, 'allItems');
    } else {
      deleteContentFromPlaylist([setToDelete]);
    }
  };

  const openModal = (type, contentKey) => {
    // setIsPlaylist(type === "playlist");
    setItemType(type);
    setSetToDelete(contentKey ? contentKey : null);
    setShowModal(true);
  };

  const dragStart = (event, contentKey) => {
    const data = JSON.stringify({
      sourcePlaylist: playlist,
      contentKey: contentKey
    });
    event.dataTransfer.setData("source_data", data);
  };

  useEffect(() => {
    const asyncPostPlaylist = async (data) => {
      setLoading(true);
      const postPlaylist = await makeRequest("GET", `/api/playlist/getcontentitems?contentKeys=${data.join()}`);
      setPosts(postPlaylist);
      setLoading(false);
    }
    if (!!selectedContentKeys.length) {
      asyncPostPlaylist(selectedContentKeys)
    } else {
      setPosts([]);
    }
  }, [selectedContentKeys]);

  return (
    <div>
      {showModal && (
        <DeletePlaylistModal
          itemType={itemType}
          closeModal={() => setShowModal(false)}
          deleteItem={deleteItem}
          playlist={playlist}
        ></DeletePlaylistModal>
      )}

      <div className="sm:hidden text-sm text-center">
        Swipe here to scroll through your playlist&nbsp;
        <i className="fa fa-arrow-right" />
      </div>

      <div className="flex justify-end m-3">
        {!playlist.isDefault && (
          <button
            onClick={() => openModal("playlist")}
            className="p-3 rounded border border-red-800 bg-white text-red-600 hover:bg-red-800 hover:text-white shadow font-bold"
          >
            <span className="hidden sm:inline mr-2">Delete Playlist</span>
            <i className="fas fa-trash-alt"></i>
          </button>
        )}

        {playlist.isDefault && playlist?.contentKeys.length > 0 && (
          <button
            onClick={() => openModal("allItems")}
            className="p-3 rounded border border-red-800 bg-white text-red-600 hover:bg-red-800 hover:text-white shadow font-bold"
          >
            <span className="hidden sm:inline mr-2">Delete All Items</span>
            <i className="fas fa-trash-alt"></i>
          </button>
        )}
      </div>

      {!loading && posts?.length && (
        <div className="flex h-full flex-no-wrap sm:flex-wrap sm:justify-center md:justify-start">
          {posts?.map((contentKey, index) => (
            <div
              className="relative min-h-full content-container"
              key={`${contentKey}${index}`}
            >
              <button
                onClick={() => openModal("item", contentKey)}
                className="absolute pin-t inline-block p-1 rounded-sm border border-red-800 bg-white text-md text-red-600 hover:bg-red-800 hover:text-white shadow font-bold"
                style={{ right: "8px" }}
              >
                <i className="far fa-times-circle"></i>
              </button>
              <div
                className="flex cursor-pointer mx-2 min-h-full"
                draggable
                onDragStart={event => dragStart(event, contentKey)}
              >
                <CardSwitcher
                  key={`postitem-${contentKey}`}
                  post={contentKey}
                  fullcard={false}
                />
              </div>
            </div>
          ))}
        </div>
      ) || (<></>)}

      {loading && (
        <div className="flex justify-center">
          <i className="fas fa-spin fa-spinner mr-3" />
          Loading playlist...
        </div>
      )}

      {!loading && !posts?.length && (
        <div className="flex justify-center">
          <p>This playlist is empty</p>
        </div>
      )}
    </div>
  );
};

export default PlaylistView;
